import { render } from "./AppProductDetail.vue?vue&type=template&id=bb57307e&scoped=true"
import script from "./AppProductDetail.vue?vue&type=script&lang=js"
export * from "./AppProductDetail.vue?vue&type=script&lang=js"

import "./AppProductDetail.vue?vue&type=style&index=0&id=bb57307e&scoped=true&lang=css"
import "./AppProductDetail.vue?vue&type=style&index=1&id=bb57307e&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb57307e"]])

export default __exports__